module.exports = __webpack_public_path__ + "static/desktop/img/life-2.44bed77b.jpg";